import {inject} from "@angular/core";
import {Router, ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable, of, EMPTY} from "rxjs";
import {mergeMap, take} from "rxjs/operators";
import {LiveResultsService} from "@services";
import {LANDING_ROUTE} from "../app-routing.module";
import {EventItem} from "@model";

export const ListOfLiveEventsResolver: ResolveFn<Observable<EventItem[] | null> |
  Promise<EventItem> | EventItem[]> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   liveResultsService: LiveResultsService = inject(LiveResultsService),
   router: Router = inject(Router)): Observable<EventItem[] | null> |
    Promise<EventItem[]> | EventItem[] => {
    return liveResultsService.fetchLiveEvents(
      true)
      .pipe(take(1),
        mergeMap((res: EventItem[] | null) => {
          if (res) {
            return of(res);
          } else {
            router.navigate([LANDING_ROUTE]);
            return EMPTY;
          }
        })
      );

  }
